import React from 'react';
import { connect } from 'react-redux'; // to connect to redux store from containers redux.js or any other redux store
import { withRouter } from 'react-router';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component


import { sessionSelector } from './Session.redux';
import { isSessionValid, logoutUser, logoutCurrentUserForAdmin } from './Session.actions';


export default function Session(Component) {
  class Child extends React.Component {


    static propTypes = {
      isSessionValid: PropTypes.func,
      isValid: PropTypes.bool.isRequired,
      history: PropTypes.func.isRequired,
    };
    static defaultProps = {
      isSessionValid: () => {},
    };

    constructor(props) {
      super(props);
      this.state = {/* inital state */};
    }

    componentDidMount() {
      this.props.isSessionValid();
    }

    componentWillReceiveProps(nextProps) {
      const { isValid } = nextProps;

      if (!isValid && this.props.history.location.pathname !== '/') {
        this.props.history.push('/');
      }
    }


    render() {
            // here you can pass down whatever you want 'inherited' by the child
      return <Component {...this.props} {...this.state} />;
    }

    }

  return connect(sessionSelector, {
    isSessionValid,
    logoutUser,
    logoutCurrentUserForAdmin,
  })(withRouter(Child));
}



// WEBPACK FOOTER //
// ./src/components/Session/Session.js